import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';
import { captureSessionFromFragment } from './api/client';
import './styles.css';

// Runs before the first render so the very first API call already carries the
// session, and the token is out of the URL before anything can read it.
captureSessionFromFragment();

const root = document.getElementById('root');
if (!root) throw new Error('#root is missing from index.html');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
